import { formatDateToBEFormatDateFns } from 'utils/date'

export const getAvailableActionsForEvent = ({
  currentEvent,
  date,
  serviceActions,
  selectedDayEvents,
  allowDuplicateEvents = true,
}) => {
  if (!serviceActions) return []
  if (!selectedDayEvents || selectedDayEvents.length === 0) return serviceActions

  if (allowDuplicateEvents) return serviceActions

  const currentActionId = currentEvent ? currentEvent.actionId : null
  const formattedDate = formatDateToBEFormatDateFns(date)

  return serviceActions.filter(action => {
    const actionId = action.id

    if (currentActionId && actionId === currentActionId) {
      return true
    }

    return !selectedDayEvents.some(event => {
      if (currentEvent && event.id === currentEvent.id) {
        return false
      }

      return event.actionId === actionId && event.serviceDate === formattedDate
    })
  })
}
